export default __webpack_public_path__ + "static/media/detoxdrinks@3x.c2c1856b.jpg";